import React, { createContext, useContext, useState } from 'react';

const LoginPasswordContext = createContext([]);

export function LoginPasswordProvider({ children }) {
  const [expiredLink, setExpiredLink] = useState(false);

  const contextValues = {
    expiredLink,
    setExpiredLink,
  };

  return (
    <LoginPasswordContext.Provider value={contextValues}>{children}</LoginPasswordContext.Provider>
  );
}

export function useLoginPassword() {
  return useContext(LoginPasswordContext);
}
